interface InfoBoxProps {
    type: "error" | "warning" | "success"
    message: string
}

export function InfoBox({ type, message }: InfoBoxProps): JSX.Element | null {
    switch (type) {
        case "error":
            return <div className="error-message alert-danger mb-3">{message}</div>

        case "warning":
            return <div className="status-message alert-warning">{message}</div>

        case "success":
            return <div className="status-message alert-success">{message}</div>

        default:
            return null
    }
}
